import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

export default function GlobalCustomPopup({
  handleClose,
  component,
  open,
  maxWidth,
  title,
  titleColor,
  titleAlign,
  hideCrossButton=false
}) {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px", // 👈 custom border radius here
          overflow: "visible", // allow content to expand
          height: "auto",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        textAlign={titleAlign ? titleAlign : "start"}
        color={titleColor ? titleColor : "#572575"}
        // fontFamily="Inter"
        fontSize="18px"
        letterSpacing="0px"
        style={{background:"#572575",height:"50px", fontWeight: 400 , borderRadius:"16px 16px 0px 0px",display:"flex",alignItems:"center",justifyContent:"space-between"}}
        
      >
        {title ? title : ""}{" "}
        {!hideCrossButton && ( 
        <IconButton
          edge="end"
          onClick={handleClose}
          aria-label="close"
          sx={{ position: "absolute", right: 15, top: 2 }}
        >
          <CloseIcon fontSize="medium" style={{color:"white"}} />
        </IconButton>
        )}
      </DialogTitle>
      <DialogContent>{component}</DialogContent>
    </Dialog>
  );
}
